// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YQOq5Mu3kOPsJkHbL9uQ{width:290px}.qzq2I9zgeQYzVQh_Zpke{border-top:1px var(--border-neutral-default)solid;padding:4px}.lGPH_INOc4wWjLFeZEq0,.UcG6ISfvbrcQ25McUQR8{justify-content:center;align-items:center;padding:15px;display:flex}.oWPOlBEixUYb5r6P9Z6H{height:100%;color:var(--content-primary-primary);text-overflow:ellipsis;padding:4px;font-size:13px;font-weight:400}.xsVrhkmjK3kvzNxQwKfz{background:var(--background-primary-inverted-primary);border:none;border-radius:6px;outline:none;padding:12px}.ZlnzrrMKWJ0qWQ1QmezS{border-bottom:1px solid var(--border-neutral-default)}.Nw8PVvvlHsIrZF0p5c_5{background-color:var(--border-neutral-default);width:100%;height:1px;margin:4px 0}.ueJNC4inQX4GZQ_SSUpA{color:var(--gray-60);justify-content:center;align-items:center;padding:15px;display:flex}.q0znvgLOF24dQav_yY4H{padding:8.5px 12px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YQOq5Mu3kOPsJkHbL9uQ`,
	"clear": `qzq2I9zgeQYzVQh_Zpke`,
	"spinner": `lGPH_INOc4wWjLFeZEq0`,
	"epmtyList": `UcG6ISfvbrcQ25McUQR8`,
	"list": `oWPOlBEixUYb5r6P9Z6H`,
	"search": `xsVrhkmjK3kvzNxQwKfz`,
	"searchWrap": `ZlnzrrMKWJ0qWQ1QmezS`,
	"divider": `Nw8PVvvlHsIrZF0p5c_5`,
	"emptyList": `ueJNC4inQX4GZQ_SSUpA`,
	"limitInfo": `q0znvgLOF24dQav_yY4H`
};
export default ___CSS_LOADER_EXPORT___;
